@if (inited) {
    <div class="project-planning-main flex-col height100p">
        <sm-tab-view id="viewTabs" class="flex-item-fill full-height" [(value)]="activeTabIndex" contentLoadMode="lazy"
            (valueChange)="changeTab()">
            <sm-tab [value]="tabs[0].id" [header]="tabs[0].title" tabClass="width150 main-tab">
                <app-planning-view-my-workspace *smTabContent #planningViewMyWorkspace></app-planning-view-my-workspace>
            </sm-tab>
            <sm-tab [value]="tabs[1].id" [header]="tabs[1].title" tabClass="width150 main-tab">
                <app-planning-view-company *smTabContent #planningViewCompany></app-planning-view-company>
            </sm-tab>
            <sm-tab [value]="tabs[2].id" [header]="tabs[2].title" tabClass="width150 main-tab">
                <app-planning-view-documents *smTabContent></app-planning-view-documents>
            </sm-tab>
            <sm-tab [value]="tabs[3].id" [header]="tabs[3].title" tabClass="width150 main-tab">
                <app-planning-view-project-overview *smTabContent></app-planning-view-project-overview>
            </sm-tab>
            <sm-tab [value]="tabs[4].id" [header]="tabs[4].title" tabClass="width150 main-tab">
                <app-planning-view-projects1 *smTabContent #planningViewProjects1></app-planning-view-projects1>
            </sm-tab>
            <sm-tab [value]="tabs[5].id" [header]="tabs[5].title" tabClass="width150 main-tab">
                <app-planning-view-projects2 *smTabContent #planningViewProjects2></app-planning-view-projects2>
            </sm-tab>
        </sm-tab-view>

        @if (app.isBeta) {
            <button class="project-planning-global-search-trigger" pButton type="button" icon="fas fa-search"
                [pTooltip]="app.t('ProjectPlanning.globalSearchTooltip')" tooltipPosition="left" (click)="globalSearchPopover.toggle($event)"></button>
            <p-popover #globalSearchPopover (onShow)="globalSearchInput.focus()">
                <div class="project-planning-global-search-content">
                    <input #globalSearchInput class="project-planning-global-search-input" pInputText type="text" inputmode="numeric"
                        [(ngModel)]="globalSearchEventId" [placeholder]="app.t('ProjectPlanning.globalSearchEventId')" (keydown.enter)="searchCalendarEvent()">
                    <button pButton type="button" icon="fas fa-arrow-right" [pTooltip]="app.t('ProjectPlanning.globalSearchGo')"
                        [disabled]="!globalSearchEventId" (click)="searchCalendarEvent()"></button>
                </div>
            </p-popover>
        }
    </div>

<div class="reminder-container">
    @for (item of summary.reminder; track item.eventId) {
        <div class="reminder">
            <div class="reminder-header">
                <div class="reminder-title-container">
                    <i class="fas fa-exclamation-circle reminder-icon"></i>
                    <span class="reminder-title">
                        {{app.t(item.eventKind == _CalendarEventKind.appointment ? 'ProjectPlanning.reminderForAppointment' : 'ProjectPlanning.reminderForTask', { date: _Dates.formatDefaultDate(item.eventStartDate) })}}
                    </span>
                </div>

                <i class="fas fa-times reminder-close" (click)="reminderDone(item.eventId)"></i>
            </div>

            <div class="reminder-body">
                <span class="reminder-text" (click)="reminderClick(item)" [tp]="_CalendarEventToolTipComponent" [tpData]="{event: item.event}" [tpDelay]="[500, 0]" tpPlacement="top-end" tpVariation="tooltip">
                    {{ item.eventTitle }}
                </span>
            </div>
        </div>
    }
</div>
}
